/**
 * @generated SignedSource<<5b23e8ea95e97a3e4d9ce4228dd010b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DescriptionContentMedia_Media$data = ReadonlyArray<{
  readonly __typename: "Image";
  readonly id: string;
  readonly sizes: ReadonlyArray<{
    readonly height: number;
    readonly width: number;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"Image_image">;
  readonly " $fragmentType": "DescriptionContentMedia_Media";
}>;
export type DescriptionContentMedia_Media$key = ReadonlyArray<{
  readonly " $data"?: DescriptionContentMedia_Media$data;
  readonly " $fragmentSpreads": FragmentRefs<"DescriptionContentMedia_Media">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "DescriptionContentMedia_Media",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageSize",
      "kind": "LinkedField",
      "name": "sizes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "height",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "width",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Image_image"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    }
  ],
  "type": "Image",
  "abstractKey": null
};

(node as any).hash = "2f2f75d7b9001477561ef57c7d7fc44c";

export default node;
